import { DepartmentModel } from '../ts/interfaces/models/DepartmentModel';
import { BaseService } from './baseService';

class DepartmentService extends BaseService<DepartmentModel> {
  controllerName = 'department';
}

export const departmentService = new DepartmentService();
